// WHAT: Component for displaying status messages
// WHY:  Separates message UI from main component to reduce complexity
// DOMAIN: Settings → SwitchBot
// DEPENDENCIES: React, @/components/ui

import React from "react";

import { Card } from "@/components/ui";

interface StatusMessageProperties {
  /** Message to display */
  message?: string;
}

/**
 * WHAT:
 *   Component for displaying status messages.
 *
 * WHY:
 *   Separates message UI from main component to reduce complexity.
 *
 * @param root0
 *
 * @param root0.message
 *
 * @returns {JSX.Element | null} Status message component or null
 *
 */
export const StatusMessage: React.FC<StatusMessageProperties> = ({ message }) => {
  if (!message) {
    return null;
  }

  const isSuccess = message.includes("✅");

  return (
    <Card
      className={
        isSuccess ? "bg-green-500/10 border-green-500/20" : "bg-red-500/10 border-red-500/20"
      }
      padding="md"
      variant="default"
    >
      <p className={`text-sm ${isSuccess ? "text-green-300" : "text-red-300"}`}>{message}</p>
    </Card>
  );
};

